module.exports = __webpack_public_path__ + "media/images/badge/prime-armi-da0460387b51b9599f506e2a18d3c6ff.png";